import { useMutation, useQueryClient } from '@tanstack/react-query';
import { remove as removeRequest } from './requests';
import { toast } from 'react-toastify';
import { QueryKey } from 'api/model';
import { errorHandler } from 'api/axios_instance';

const queryKey = QueryKey.FileManagement;

const useSingleFileManagment = (fileId: string) => {
  const queryClient = useQueryClient();

  const remove = useMutation({
    mutationFn: () => removeRequest(fileId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      toast.success('File successfully removed');
    },
    onError: errorHandler('Removing file failed'),
  });

  return { remove };
};

export default useSingleFileManagment;
